'use client';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { IoChevronDown } from 'react-icons/io5';

export const FilterContainer = ({
  children,
  title,
  isFromSearch,
  selected = 0,
}) => {
  const t = useTranslations('common');
  const [open, setOpen] = useState(false);

  return (
    <div className='border-border-50 rounded-2xl border p-4'>
      {/* HEADER */}
      <header
        className={`flex cursor-pointer items-center justify-between`}
        onClick={() => setOpen((o) => !o)}
      >
        <h2 className='font-bold'>{isFromSearch ? t(title) : title}</h2>

        <div className='flex items-center gap-2'>
          <span className='text-xs text-gray-500'>
            {selected} {t('selected')}
          </span>

          {/* Arrow */}
          <IoChevronDown
            className={`h-4 w-4 text-gray-600 transition-transform duration-300 ${
              open ? 'rotate-180' : ''
            }`}
          />
        </div>
      </header>

      {/* CONTENT */}
      <div
        className={`overflow-hidden transition-all duration-300 ${
          open ? 'mt-3 max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {children}
      </div>
    </div>
  );
};
